import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CheckActiveRolePipe} from './check-active-role.pipe';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CheckActiveRolePipe
  ],
  exports: [CheckActiveRolePipe]
})
export class CheckActiveRoleModule { }
